import style from './map.module.scss';
import React, {useEffect, useRef, useState} from "react";
import {clearMap, searchMap} from "../../util/assets";

function SearchBox({setCenter, getDevicesByMap}) {
    const autocompleteContainerRef = useRef(null);
    const autocompleteRef = useRef(null);
    const lastCoordRef = useRef(null);
    const [isMounted, setIsMounted] = useState(false);

    const applyCoord = coord => {
        if (!coord) return;
        lastCoordRef.current = coord;
        setCenter(coord);
        //0.045 ~ 10km
        const quat = JSON.stringify([[coord.lat + 0.045, coord.lng - 0.045],[coord.lat - 0.045, coord.lng + 0.045]]);//[[top left], [bottom right]]
        getDevicesByMap({center: JSON.stringify([coord.lat, coord.lng]), coordinates: quat});
    };

    const clearInputSearch = () => {
        lastCoordRef.current = null;
        const autocomplete = autocompleteRef.current;
        if (!autocomplete) return;
        if ("value" in autocomplete) {
            autocomplete.value = "";
            return;
        }
        if (autocomplete.inputElement) {
            autocomplete.inputElement.value = "";
        }
    };

    const onSearchClick = () => {
        applyCoord(lastCoordRef.current);
    };

    useEffect(() => {
        const onPlaceSelect = async event => {
            const placePrediction = event.placePrediction || event.detail?.placePrediction;
            if (!placePrediction) return;
            const place = placePrediction.toPlace();
            await place.fetchFields({fields: ["location"]});
            const location = place.location || place.geometry?.location;
            if (!location) return;
            applyCoord({lat: location.lat(), lng: location.lng()});
        };

        const init = async () => {
            const container = autocompleteContainerRef.current;
            if (!container) return;
            const maps = window.google?.maps;
            if (!maps?.importLibrary) return;

            const {PlaceAutocompleteElement} = await maps.importLibrary("places");
            if (!autocompleteContainerRef.current) return;

            if (autocompleteRef.current?.parentNode) {
                autocompleteRef.current.parentNode.removeChild(autocompleteRef.current);
            }

            const element = new PlaceAutocompleteElement();
            element.placeholder = "Search...";
            autocompleteRef.current = element;
            // Базовая стилизация хоста (shadow DOM может быть закрыт)
            element.style.width = "100%";
            element.style.minWidth = "200px";
            element.style.border = "none";
            element.style.boxShadow = "none";
            element.style.outline = "none";
            element.style.background = "#fff";
            element.style.padding = "0";
            element.style.borderRadius = "37px";
            element.style.color = "#1E1E1E";
            element.style.colorScheme = "light";
            container.appendChild(element);
            element.addEventListener("gmp-select", onPlaceSelect);
        };

        init();

        return () => {
            if (autocompleteRef.current) {
            }
            if (autocompleteRef.current?.parentNode) {
                autocompleteRef.current.parentNode.removeChild(autocompleteRef.current);
            }
            autocompleteRef.current = null;
        };
    }, [getDevicesByMap, setCenter, isMounted]);

    return (
        <>
            <div className={style.searchBlock}>
                <div className={style.findInput}>
                    <div className={style.autocompleteContainer} ref={autocompleteContainerRef}/>
                    <div className={style.searchButton} onClick={onSearchClick}>
                        <img src={searchMap} alt=""/>
                    </div>
                    <div className={style.closeButton} onClick={clearInputSearch}>
                        <img src={clearMap} alt=""/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SearchBox;